import { render, staticRenderFns } from "./ClubDetail.vue?vue&type=template&id=30ca2a2a&scoped=true"
import script from "./ClubDetail.vue?vue&type=script&lang=js"
export * from "./ClubDetail.vue?vue&type=script&lang=js"
import style0 from "./ClubDetail.vue?vue&type=style&index=0&id=30ca2a2a&prod&scoped=true&lang=css"
import style1 from "./ClubDetail.vue?vue&type=style&index=1&id=30ca2a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca2a2a",
  null
  
)

export default component.exports